const domainRoleLabels = {
  superadmin: 'Super Administrator',
  admin: 'Administrator',
  standard: 'Standard User',
  restricted: 'Restricted User',
};

export default domainRoleLabels;
